import { render, staticRenderFns } from "./ProductReportsDashboardBriefModal.vue?vue&type=template&id=994d60ea&scoped=true"
import script from "./ProductReportsDashboardBriefModal.vue?vue&type=script&lang=js"
export * from "./ProductReportsDashboardBriefModal.vue?vue&type=script&lang=js"
import style0 from "./ProductReportsDashboardBriefModal.vue?vue&type=style&index=0&id=994d60ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994d60ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('994d60ea')) {
      api.createRecord('994d60ea', component.options)
    } else {
      api.reload('994d60ea', component.options)
    }
    module.hot.accept("./ProductReportsDashboardBriefModal.vue?vue&type=template&id=994d60ea&scoped=true", function () {
      api.rerender('994d60ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/product-reports-dashboard/ProductReportsDashboardBriefModal.vue"
export default component.exports